/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MessageKind = {
    Text: 'TEXT',
    Location: 'LOCATION',
    Image: 'IMAGE',
    Video: 'VIDEO',
    Audio: 'AUDIO',
    RequestLocation: 'REQUEST_LOCATION'
} as const;
export type MessageKind = typeof MessageKind[keyof typeof MessageKind];


export function instanceOfMessageKind(value: any): boolean {
    for (const key in MessageKind) {
        if (Object.prototype.hasOwnProperty.call(MessageKind, key)) {
            if (MessageKind[key as keyof typeof MessageKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MessageKindFromJSON(json: any): MessageKind {
    return MessageKindFromJSONTyped(json, false);
}

export function MessageKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageKind {
    return json as MessageKind;
}

export function MessageKindToJSON(value?: MessageKind | null): any {
    return value as any;
}

export function MessageKindToJSONTyped(value: any, ignoreDiscriminator: boolean): MessageKind {
    return value as MessageKind;
}

